import { createReducer } from '@reduxjs/toolkit';
import { unsetEmpresasAction, setEmpresasAction } from './empresasActions';
import { EmpresaState } from './empresasTypes';

export const initialState: EmpresaState = [];

const empresasReducer = createReducer(initialState, {
  [setEmpresasAction.toString()]: (state, action) => {
    return action.payload;
  },
  [unsetEmpresasAction.toString()]: (state, action) => {
    return [];
  }
});

export default empresasReducer;
